import angular from 'angular';
import uiRouter from 'angular-ui-router';
import commonicdchangesbydrgComponent from './commonicdchangesbydrg.component';

let commonicdchangesbydrgModule = angular.module('commonicdchangesbydrg', [
  uiRouter
])

.component('commonicdchangesbydrg', commonicdchangesbydrgComponent);

export default commonicdchangesbydrgModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/commonicdchangesbydrg/commonicdchangesbydrg.js